import api from "./api";

const BASE_URL = "/sms";

const smsService = {
  sendSms: async ({ to, body, patientId, locationId, from }) => {
    return api.post(`${BASE_URL}/send`, { to, body, patientId, locationId, from });
  },

  getConversations: async (locationId, { page = 1, limit = 50 } = {}) => {
    const params = new URLSearchParams();
    if (locationId) params.append("locationId", locationId);
    params.append("page", page);
    params.append("limit", limit);
    return api.get(`${BASE_URL}/conversations?${params}`);
  },

  getThread: async (contactPhone, { page = 1, limit = 50 } = {}) => {
    const params = new URLSearchParams({ page, limit });
    return api.get(`${BASE_URL}/thread/${encodeURIComponent(contactPhone)}?${params}`);
  },

  markThreadRead: async (contactPhone) => {
    return api.put(`${BASE_URL}/thread/${encodeURIComponent(contactPhone)}/read`);
  },

  getUnreadCount: async (locationId) => {
    const params = new URLSearchParams();
    if (locationId) params.append("locationId", locationId);
    return api.get(`${BASE_URL}/unread-count?${params}`);
  },
};

export default smsService;
